"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getWindowScrollPosition = function getWindowScrollPosition() {
  return window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
};
var _default = exports["default"] = getWindowScrollPosition;